import { cookieConsentSchema } from '../model/cookie-consent.schema';
import { CookieConsent } from '../model/cookie-consent.types';


export function parseCookieConsent (
    value: string | undefined,
): CookieConsent | null {
    if (!value) {
        return null;
    }

    try {
        const parsed: unknown = JSON.parse(decodeURIComponent(value));

        return cookieConsentSchema.parse(parsed);
    } catch {
        return null;
    }
}
